import React, { useState, useEffect } from 'react';
import './Carousel.css';

const Carousel = ({ slides, auth, interval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToPrevious = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
    };

    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
    };

    const starCount = [1, 2, 3, 4, 5];

    useEffect(() => {
        const nextSlide = setInterval(goToNext, interval);
        return () => clearInterval(nextSlide); // Cleanup on unmount
    }, [currentIndex, interval]);

    return (
        <div className="carousel-container">
            <div className="carousel-content">
                {slides.map((slide, index) => (
                    <div
                        key={`slide-${index}`}
                        className="carousel-slide"
                        style={{
                            opacity: index === currentIndex ? 1 : 0,
                            transition: 'opacity 0.5s ease-in-out',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            visibility: index === currentIndex ? 'visible' : 'hidden', // Ensure hidden slides don't capture events
                        }}
                    >
                        <div style={{ marginBottom: '20px' }}>
                            {starCount.map((count, ind) => (
                                <i key={`item1-${ind}`} className="star fa-regular fa-star"></i>
                            ))}
                        </div>
                        <div style={{ marginBottom: '20px' }}>"{slide}"</div>
                        <div>- {auth[index]}</div>
                    </div>
                ))}
            </div>
            <button className="carousel-button landing-page-carousel prev" onClick={goToPrevious}>
                <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button className="carousel-button landing-page-carousel next" onClick={goToNext}>
                <i className="fa-solid fa-chevron-right"></i>
            </button>
        </div>
    );
};

export default Carousel;
